import PropTypes from 'prop-types';
import attentionImage1 from '../images/attention_image1.png';
import attentionImage2 from '../images/attention_image2.png';

import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Stack from '@mui/material/Stack';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';

const TextAndImage = (props) => {
  return (
    <Stack>
      <Stack direction='row' spacing={1} marginBottom='16px' width='256px' height='64px' >
        <Typography variant='label14' >
          {props.number}
        </Typography>
        <Typography whiteSpace='pre-wrap' variant='label14'>
          {props.text}
        </Typography>
      </Stack>
      <img src={props.src} alt='注意喚起情報 選択時のDTAC側表示イメージ' width='256px' height='341px' />
    </Stack>
  );
};

const NextIcon = () => {
  return (
    <Stack justifyContent='center' padding='0px 16px' height='341px'>
      <NavigateNextIcon sx={{ color: 'darkgray' }} />
    </Stack>
  );
};

const AttentionImageDialog = (props) => {
  const handleClose = () => {
    props.setOpen(false);
  };

  return (
    <Dialog
      open={props.open}
      onClose={handleClose}
      maxWidth='lg'
    >
      <DialogTitle variant='body16bold' textAlign='center' position='relative'>
        注意喚起情報 選択時のDTAC側表示イメージ
        <IconButton
          sx={{ position: 'absolute', right: '6px', top: '0px', bottom: '0px' }}
          onClick={handleClose}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers sx={{ padding: '47px 108px 74px 104px' }}>
        <Stack direction='row' alignItems='end'>
          <TextAndImage
            number='①'
            text={'送信先のDTAC画面上部に\n通知バーが表示され\n画面全体の色が変化する'}
            src={attentionImage1}
          />
          <NextIcon />
          <TextAndImage
            number='②'
            text={'通知バーをタップすると\n通知バーが消え\n画面全体の色が元に戻る'}
            src={attentionImage2}
          />
        </Stack>
      </DialogContent>
    </Dialog>
  );
};

export default AttentionImageDialog;

TextAndImage.propTypes = {
  number: PropTypes.string,
  text: PropTypes.string,
  src: PropTypes.string,
};

AttentionImageDialog.propTypes = {
  open: PropTypes.bool,
  setOpen: PropTypes.func,
};
